export default __webpack_public_path__ + "static/media/rectangle@3x.400fc2d6.png";